"use strict";
import React from "react";
import moment from "moment";
import generalFormatter from "../formatters/general";
function matchIcon(a, b) {
  return /* @__PURE__ */ React.createElement("div", { className: a === b ? "fi-checkbox success" : "fi-x-circle alert" });
}
function formatDate(date) {
  return moment(date).format("MM/DD/YYYY");
}
function invoiceAmount(invoice) {
  return generalFormatter.currency(invoice.invoiceAmount);
}
function warningClass(a, b) {
  return a === b ? "" : "mismatched";
}
const DuplicateBrokerInvoiceConfirmation = React.createClass({
  getInitialState() {
    return {
      decisionError: false,
      storingNotDupe: false,
      savingDupe: false
    };
  },
  saveNotDupe() {
    this.setState({ storingNotDupe: true, decisionError: false });
    this.props.onClose().then((resp) => {
      if (resp === false)
        this.setState({
          decisionError: "Failure storing 'not duplicate' decision"
        });
    }).finally(() => this.setState({ storingNotDupe: false }));
  },
  saveDupe() {
    this.setState({ savingDupe: true, decisionError: false });
    this.props.onMarkAsDupe().then((resp) => {
      if (resp === false)
        this.setState({
          decisionError: "Failure storing 'yes duplicate' decision"
        });
    }).finally(() => this.setState({ savingDupe: false }));
  },
  render: function() {
    const saving = this.state.storingNotDupe || this.state.savingDupe;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        "data-component": "DuplicateBrokerInvoiceConfirmation",
        className: "load-assigner__duplicate-broker-invoice-confirmation"
      },
      /* @__PURE__ */ React.createElement("h3", null, "Is this a duplicate of invoice", " ", this.props.approvedInvoice.invoiceNumber, " for load", " ", this.props.approvedInvoice.loadId, "?"),
      /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution" }, /* @__PURE__ */ React.createElement("em", null, "Warning - "), /* @__PURE__ */ React.createElement("span", null, "There is already an approved invoice for ", this.props.carrierName, " on the load")),
      /* @__PURE__ */ React.createElement("table", { className: "duplicate-table" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Invoice details"), /* @__PURE__ */ React.createElement("th", null, "Approved Invoice"), /* @__PURE__ */ React.createElement("th", null, "Invoice on current email"), /* @__PURE__ */ React.createElement("th", null, "Match"))), /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, "Sender Email"), /* @__PURE__ */ React.createElement("td", null, this.props.approvedInvoice.senderEmail), /* @__PURE__ */ React.createElement(
        "td",
        {
          className: warningClass(
            this.props.approvedInvoice.senderEmail,
            this.props.submission.senderEmail
          )
        },
        this.props.submission.senderEmail
      ), /* @__PURE__ */ React.createElement("td", null, matchIcon(
        this.props.approvedInvoice.senderEmail,
        this.props.submission.senderEmail
      ))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, "Invoice Amount"), /* @__PURE__ */ React.createElement("td", null, invoiceAmount(this.props.approvedInvoice)), /* @__PURE__ */ React.createElement(
        "td",
        {
          className: warningClass(
            this.props.approvedInvoice.invoiceAmount,
            this.props.submission.invoiceAmount
          )
        },
        invoiceAmount(this.props.submission)
      ), /* @__PURE__ */ React.createElement("td", null, matchIcon(
        this.props.approvedInvoice.invoiceAmount,
        this.props.submission.invoiceAmount
      ))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, "Invoice Number"), /* @__PURE__ */ React.createElement("td", null, this.props.approvedInvoice.invoiceNumber), /* @__PURE__ */ React.createElement(
        "td",
        {
          className: warningClass(
            this.props.approvedInvoice.invoiceNumber,
            this.props.submission.invoiceNumber
          )
        },
        this.props.submission.invoiceNumber
      ), /* @__PURE__ */ React.createElement("td", null, matchIcon(
        this.props.approvedInvoice.invoiceNumber,
        this.props.submission.invoiceNumber
      ))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, "Invoice Date"), /* @__PURE__ */ React.createElement("td", null, formatDate(this.props.approvedInvoice.invoiceDate)), /* @__PURE__ */ React.createElement(
        "td",
        {
          className: warningClass(
            this.props.approvedInvoice.invoiceDate.getTime(),
            this.props.submission.invoiceDate.getTime()
          )
        },
        formatDate(this.props.submission.invoiceDate)
      ), /* @__PURE__ */ React.createElement("td", null, matchIcon(
        this.props.approvedInvoice.invoiceDate.getTime(),
        this.props.submission.invoiceDate.getTime()
      ))))),
      this.state.decisionError && /* @__PURE__ */ React.createElement("div", { className: "alert-box alert-box--caution centered" }, this.state.decisionError),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end"
          }
        },
        /* @__PURE__ */ React.createElement(
          "button",
          {
            disabled: saving,
            onClick: this.saveNotDupe,
            className: ["button--cancel", ...saving ? ["disabled"] : []].join(
              " "
            )
          },
          "No"
        ),
        /* @__PURE__ */ React.createElement(
          "button",
          {
            disabled: saving,
            onClick: this.saveDupe,
            className: ["button", ...saving ? ["disabled"] : []].join(" ")
          },
          "Yes, Ignore the duplicate"
        )
      )
    );
  }
});
export default DuplicateBrokerInvoiceConfirmation;
